// @generated by protoc-gen-connect-es v1.7.0 with parameter "target=ts"
// @generated from file config_service.proto (package cuda_learning, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { GetAvailableToolsRequest, GetAvailableToolsResponse, GetProcessorStatusRequest, GetProcessorStatusResponse, GetStreamConfigRequest, GetStreamConfigResponse, GetSystemInfoRequest, GetSystemInfoResponse, ListFeatureFlagsRequest, ListFeatureFlagsResponse, ListInputsRequest, ListInputsResponse, UpsertFeatureFlagRequest, UpsertFeatureFlagResponse } from "./config_service_pb.js";
import { MethodIdempotency, MethodKind } from "@bufbuild/protobuf";

/**
 * @generated from service cuda_learning.ConfigService
 */
export const ConfigService = {
  typeName: "cuda_learning.ConfigService",
  methods: {
    /**
     * @generated from rpc cuda_learning.ConfigService.GetStreamConfig
     */
    getStreamConfig: {
      name: "GetStreamConfig",
      I: GetStreamConfigRequest,
      O: GetStreamConfigResponse,
      kind: MethodKind.Unary,
      idempotency: MethodIdempotency.NoSideEffects,
    },
    /**
     * @generated from rpc cuda_learning.ConfigService.ListFeatureFlags
     */
    listFeatureFlags: {
      name: "ListFeatureFlags",
      I: ListFeatureFlagsRequest,
      O: ListFeatureFlagsResponse,
      kind: MethodKind.Unary,
      idempotency: MethodIdempotency.NoSideEffects,
    },
    /**
     * @generated from rpc cuda_learning.ConfigService.UpsertFeatureFlag
     */
    upsertFeatureFlag: {
      name: "UpsertFeatureFlag",
      I: UpsertFeatureFlagRequest,
      O: UpsertFeatureFlagResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc cuda_learning.ConfigService.ListInputs
     */
    listInputs: {
      name: "ListInputs",
      I: ListInputsRequest,
      O: ListInputsResponse,
      kind: MethodKind.Unary,
      idempotency: MethodIdempotency.NoSideEffects,
    },
    /**
     * @generated from rpc cuda_learning.ConfigService.GetAvailableTools
     */
    getAvailableTools: {
      name: "GetAvailableTools",
      I: GetAvailableToolsRequest,
      O: GetAvailableToolsResponse,
      kind: MethodKind.Unary,
      idempotency: MethodIdempotency.NoSideEffects,
    },
    /**
     * @generated from rpc cuda_learning.ConfigService.GetSystemInfo
     */
    getSystemInfo: {
      name: "GetSystemInfo",
      I: GetSystemInfoRequest,
      O: GetSystemInfoResponse,
      kind: MethodKind.Unary,
      idempotency: MethodIdempotency.NoSideEffects,
    },
    /**
     * @generated from rpc cuda_learning.ConfigService.GetProcessorStatus
     */
    getProcessorStatus: {
      name: "GetProcessorStatus",
      I: GetProcessorStatusRequest,
      O: GetProcessorStatusResponse,
      kind: MethodKind.Unary,
      idempotency: MethodIdempotency.NoSideEffects,
    },
  }
} as const;

